exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-4e87b612] {\n    color: #ffffff;\n}\n@media screen and (min-width: 576px) {\n.signContents[data-v-4e87b612] {\n        width: 420px;\n}\n}\n.signInForm[data-v-4e87b612] {\n    height: 100vh;\n}\n", ""]);

// exports
